import { INovelUser } from "@novel/shared/interfaces/NovelUser";

import { NovelGallerySubReducer } from "@customer-gallery/redux/galleryTypedRedux";
import { useNovelCustomerSelector } from "@customer-gallery/redux/reduxHooks";

export interface IAuthReducerState {
    isLoadingUser: boolean;
    authError: string | null;
    user: INovelUser | null;
    loginEmailStatus: null | "requesting" | "success" | "error";
    loginEmailErrorMessage: string | null;
    addEmailForAccountStatus: null | "requesting" | "success" | "error";
    addEmailForAccountErrorMessage: string | null;
    openSidebar: boolean;
}

const initialState: IAuthReducerState = {
    isLoadingUser: true,
    authError: null,
    user: null,
    loginEmailStatus: null,
    loginEmailErrorMessage: null,
    addEmailForAccountStatus: null,
    addEmailForAccountErrorMessage: null,
    openSidebar: false,
};

export const authReducer: NovelGallerySubReducer<IAuthReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_USER": {
            return {
                ...state,
                isLoadingUser: true,
            };
        }

        case "ERROR_LOADING_USER": {
            return {
                ...state,
                isLoadingUser: false,
                authError: action.payload.errorMessage,
            };
        }

        case "LOADED_USER": {
            return {
                ...state,
                isLoadingUser: false,
                user: action.payload.user,
            };
        }

        case "LOG_OUT": {
            return {
                ...state,
                isLoadingUser: false,
                user: null,
            };
        }

        case "CLEAR_LOGIN_TOKEN_EMAIL_STATE": {
            return {
                ...state,
                loginEmailStatus: null,
                loginEmailErrorMessage: null,
            };
        }

        case "REQUESTING_TOKEN":
        case "REQUESTING_TOKEN_CODE": {
            return {
                ...state,
                loginEmailStatus: "requesting",
                loginEmailErrorMessage: null,
            };
        }

        case "REQUESTED_TOKEN":
        case "REQUESTED_TOKEN_CODE": {
            return {
                ...state,
                loginEmailStatus: "success",
                loginEmailErrorMessage: null,
            };
        }

        case "ERROR_REQUESTING_TOKEN":
        case "ERROR_REQUESTING_TOKEN_CODE": {
            return {
                ...state,
                loginEmailStatus: "error",
                loginEmailErrorMessage: action.payload.errorMessage,
            };
        }

        case "ADDING_EMAIL_FOR_ACCOUNT": {
            return {
                ...state,
                addEmailForAccountStatus: "requesting",
            };
        }
        case "ERROR_ADDING_EMAIL_FOR_ACCOUNT": {
            return {
                ...state,
                addEmailForAccountStatus: "error",
                addEmailForAccountErrorMessage: action.payload.errorMessage,
            };
        }
        case "ADDED_EMAIL_FOR_ACCOUNT": {
            return {
                ...state,
                addEmailForAccountStatus: "success",
                addEmailForAccountErrorMessage: null,
            };
        }
        case "CLEAR_ADD_EMAIL_FOR_ACCOUNT_STATE": {
            return {
                ...state,
                addEmailForAccountStatus: null,
                addEmailForAccountErrorMessage: null,
            };
        }

        case "CHANGE_SIDEBAR_STATUS": {
            return {
                ...state,
                openSidebar: action.payload.open,
            };
        }

        case "UPDATE_USER_DETAILS": {
            return {
                ...state,
                user: action.payload.user,
            };
        }

        default: {
            return state;
        }
    }
};

export function useIsSuperUserSelector(): boolean {
    return useNovelCustomerSelector((state) => !!state.auth.user?.isSuperUser);
}
